import { render } from "./GridIcon.vue?vue&type=template&id=1dd5d2e4"
import script from "./GridIcon.vue?vue&type=script&lang=js"
export * from "./GridIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__